/**
 * Phase 9 — Microsoft Clarity injection (heatmaps + session replay).
 *
 * Consent-gated : appelé seulement si `categories.analytics === true`.
 * Idle-deferred : passe par `idleInject` côté caller.
 *
 * PHASE 10 : remplacer `REPLACE_AT_END_CLARITY_ID` par le vrai Project ID
 * fourni par Océanne (Clarity dashboard).
 */
import { idleInject } from '@/lib/perf/idle-inject';

const CLARITY_ID_PLACEHOLDER = 'REPLACE_AT_END_CLARITY_ID';
const CLARITY_ID: string = CLARITY_ID_PLACEHOLDER;

interface ClarityGlobal {
  (...args: unknown[]): void;
  q?: unknown[];
}

declare global {
  interface Window {
    clarity?: ClarityGlobal;
  }
}

export function injectClarity(projectId: string = CLARITY_ID): void {
  if (typeof window === 'undefined') return;
  if (projectId === CLARITY_ID_PLACEHOLDER) {
    if (import.meta.env.DEV) {
      console.warn('[clarity] skipped: placeholder not replaced (Phase 10)');
    }
    return;
  }
  if (window.clarity) return; // already injected

  // Official Clarity snippet (transposed inline to satisfy TS — same logic).
  const clarity: ClarityGlobal = function (...args: unknown[]) {
    (clarity.q = clarity.q ?? []).push(args);
  } as ClarityGlobal;
  window.clarity = clarity;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${projectId}`;
  const first = document.getElementsByTagName('script')[0];
  first?.parentNode?.insertBefore(script, first);
}

export function deferClarity(): void {
  idleInject(() => injectClarity());
}
